import { render, staticRenderFns } from "./DataLockIcon.vue?vue&type=template&id=30aaa1d7"
import script from "./DataLockIcon.vue?vue&type=script&lang=js"
export * from "./DataLockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports